import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'

// Header and footer persist in _app.tsx; every page wraps its content in this <main>.
export const Layout: FC<LayoutProps> = ({ children, className }): ReactNode => {
    return (
        <main id='inhalt' tabIndex={-1} className={cn('flex-1 outline-none', className)}>
            {children}
        </main>
    )
}
